import { createFeature, createReducer, on } from '@ngrx/store';
import { InterviewsListActions } from './interviews-list.actions';
import { InterviewsListFeatureState } from './interviews-list.models';

export const initialInterviewsListState: InterviewsListFeatureState = {
  filters: {
    studentId: null,
    studentLabel: null,
    fromDate: null,
    toDate: null,
    jobRole: null,
    companyName: null,
    cseAssignedId: null,
    csiAssignedId: null,
    interviewRoundTypeIds: [],
    interviewStatusId: null,
    interviewResultId: null,
    interviewEnabledById: null
  },
  pagination: {
    firstRowOffset: 0,
    pageSize: 10,
    page: 1,
    totalRecords: 0
  },
  sort: {
    sortField: '',
    sortOrder: 1,
    previousSortField: '',
    previousSortOrder: 0
  },
  gridData: null
};

const reducer = createReducer(
  initialInterviewsListState,
  on(InterviewsListActions.snapshotPersisted, (state, { snapshot }) => ({
    ...state,
    filters: snapshot.filters,
    pagination: snapshot.pagination,
    sort: snapshot.sort
  })),
  on(InterviewsListActions.gridDataCached, (state, { gridData }) => ({
    ...state,
    gridData
  })),
  on(InterviewsListActions.gridDataCleared, (state) => ({
    ...state,
    gridData: null
  })),
  on(InterviewsListActions.cleared, () => initialInterviewsListState)
);

export const interviewsListFeature = createFeature({
  name: 'interviewsList',
  reducer
});
